import React from 'react';
import LogoSvg from './LogoSvg.js';
import PropTypes from 'prop-types';

import './animatedLogoComponent.css';
const AnimatedLogoComponent = ({fillColor, backClass, eyeClass}) => {
  return (
    <div className="et-anim-logo-wrap">
      <div className="et-alw-half-left">
        <div className={'et-alw-eye-back ' + backClass}></div>
        <div className={'et-alw-eye ' + eyeClass}></div>
        <LogoSvg className="et-alw-img-left" fillColor={fillColor} />
      </div>
      <div className="et-alw-half-right">
        <div className={'et-alw-eye-back ' + backClass}></div>
        <div className={'et-alw-eye ' + eyeClass}></div>

        <LogoSvg className="et-alw-img-right" fillColor={fillColor} />
      </div>
    </div>
  );
};
LogoSvg.propTypes = {
  fillColor: PropTypes.string,
};

LogoSvg.defaultProps = {
  fillColor: '#2d2756',
};
export default AnimatedLogoComponent;
